import RestaurantRating from './rating';

export { type RestaurantRatingProps } from './rating';

export default RestaurantRating;

export { default as RestaurantRatingSkeleton } from './skeleton';
